import cloneDeep from "lodash/cloneDeep";
import set from "lodash/set";
import {
  FORM_ROLES_KEY,
  FORM_SUBTEMPLATES_KEY
} from "PFApp/constants/activity_form/activity_form_field_keys";
import { UnsavedEdit, UnsavedEdits } from "PFApp/stores/manage_roles/manage_roles_store.types";
import { ManageRolesMultiForm } from "PFApp/types/activity_form/manage_roles_form_schema";
import { Id } from "PFCore/types";

import { getRoleKey } from "../manage_roles.utils";

export const applyPendingEditsToFormData = (
  formData: ManageRolesMultiForm,
  unsavedEdits: UnsavedEdits
): ManageRolesMultiForm => {
  const editsByRoleId = new Map<Id, UnsavedEdit[]>();
  Object.values(unsavedEdits).forEach((edit) => {
    const group = editsByRoleId.get(edit.roleId) ?? [];
    group.push(edit);
    editsByRoleId.set(edit.roleId, group);
  });

  if (editsByRoleId.size === 0) {
    return formData;
  }

  return {
    ...formData,
    [FORM_SUBTEMPLATES_KEY]: (formData[FORM_SUBTEMPLATES_KEY] ?? []).map((subtemplate) => ({
      ...subtemplate,
      [FORM_ROLES_KEY]: (subtemplate[FORM_ROLES_KEY] ?? []).map((role) => {
        const pendingEdits = editsByRoleId.get(getRoleKey(role));
        if (!pendingEdits || pendingEdits.length === 0) {
          return role;
        }
        const updatedRole = cloneDeep(role);
        pendingEdits.forEach((edit) => {
          set(updatedRole, edit.fieldName, edit.value);
        });
        return updatedRole;
      })
    }))
  };
};
